import { Dispatch } from 'redux';
import { SET_USER_TOKEN } from '../../../../../core/redux/types/token-types';
import { LoginRepositoryImpl } from '../../../data/repositories/login-repository-impl';
import { LoginUsecaseImpl } from '../../../domain/usecases/login-usecase';
import { LIST_LOAD_REQUEST, LIST_LOAD_SUCCESS, LIST_LOAD_FAILURE } from '../types/login-types';

export const login = (email: string, password: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LIST_LOAD_REQUEST });

    try {
      const loginRepository = new LoginRepositoryImpl();
      const loginUsecase = new LoginUsecaseImpl(loginRepository);

      const result = await loginUsecase.Login(email, password);

      localStorage.setItem('cowabunga-master-admin', result.token);

      dispatch({ type: LIST_LOAD_SUCCESS, payload: result });
      dispatch({ type: SET_USER_TOKEN, payload: result.token });

      props.history.push('/');
    } catch (error) {
      dispatch({ type: LIST_LOAD_FAILURE, error });
    }
  };
};
